
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router';

import InstitutionService from "@/core/services/InstitutionService"
import btnBack from "@/components/buttons/btnBack.vue"
export default defineComponent({
    name: "manager-clubs",
    components: {btnBack},
    setup() {
        const loader = ref(false)
        const route = useRoute();
        const { id } = route.params
        const club = ref<any>({})

        const getInfo = async()=> {
            loader.value = true
            await InstitutionService.edit(id.toString())
            .then((res)=>{
                club.value = res.data
                loader.value = false
            }).catch(({response})=>{
                loader.value = false
            })
        }

        onMounted(()=>{
            getInfo()
        })
    
    return {
            id,
            loader,
            club,
            getInfo
        }
        
    },
})
